import React from 'react';
import Layout from '../components/layout';
import Seo from '../components/seo';
import { Link, graphql } from 'gatsby';

const Pie = ({ data }) => {
    const pageList = data.allSitePage.edges.map(a => a.node.path)
    return (
        <Layout>
            <Seo title="Pie Charts" />
            <h1 className="my-4 text-2xl dark:text-white">
                Pie Charts
            </h1>
            <p className="text-base dark:text-white">
                This is the list of all the pie charts drawn over the years.
            </p>
            <h4 className="pt-4 text-2xl dark:text-white">Following is the list</h4>
            <ul className="list-disc list-inside dark:text-white">
                {pageList ?
                    pageList.map((a, index) =>
                        <li className="p-4" key={index}>
                            <Link to={a} className="font-bold text-xl dark:text-blue-200 text-blue-500">
                                {a.split("/").reverse()[1][0].toUpperCase() + a.split("/").reverse()[1].slice(1)}
                            </Link>
                        </li>

                    ) :
                    <li></li>
                }
            </ul>
        </Layout>
    )
}

export const query = graphql`
    query PieQuery {
        allSitePage(filter: {id: {regex: "/\/pies\/[a-z]+.*/"}}) {
          edges {
            node {
              path
            }
          }
        }
      }
  `

export default Pie